import { useLocation, Link } from 'react-router-dom';
import { CheckIcon, PhoneIcon, WhatsAppIcon } from '../components/Icons';

const DAY_LABELS = { today:'Today', tomorrow:'Tomorrow', this_week:'This week', next_week:'Next week' };

export default function Confirmation() {
  const { state } = useLocation();
  const form = state?.form || {};

  return (
    <div style={{ background:'var(--cream)', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'24px' }}>
      <div style={{ background:'white', borderRadius:'var(--radius-xl)', padding:'52px 44px', maxWidth:'480px', width:'100%', textAlign:'center', boxShadow:'var(--shadow-lg)', border:'1px solid var(--cream-dark)' }}>
        <div style={{ width:'72px', height:'72px', background:'var(--teal-light)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 24px' }}>
          <CheckIcon size={32} color="var(--teal-dark)" />
        </div>
        <h1 style={{ fontSize:'30px', marginBottom:'12px', color:'var(--teal-dark)' }}>Request received!</h1>
        <p style={{ color:'var(--text-light)', fontSize:'16px', marginBottom:'28px', lineHeight:'1.7' }}>
          Thank you{form.name ? `, ${form.name}` : ''}. We will call <strong>{form.phone || 'you'}</strong> shortly to confirm your home visit.
        </p>

        {form.condition && (
          <div style={{ background:'var(--cream)', borderRadius:'var(--radius)', padding:'18px 20px', marginBottom:'28px', textAlign:'left', border:'1px solid var(--cream-dark)' }}>
            <div style={{ fontSize:'12px', fontWeight:'600', color:'var(--text-light)', marginBottom:'10px', textTransform:'uppercase', letterSpacing:'0.5px' }}>Your request</div>
            {[
              { l:'Condition', v:form.condition },
              { l:'Area', v:form.area },
              { l:'Timing', v:DAY_LABELS[form.day] || form.day },
              form.gender && { l:'Therapist preference', v: form.gender === 'female' ? 'Female therapist' : form.gender === 'male' ? 'Male therapist' : 'No preference' },
            ].filter(Boolean).map(r => (
              <div key={r.l} style={{ display:'flex', justifyContent:'space-between', fontSize:'14px', padding:'6px 0', borderBottom:'1px solid var(--cream-dark)' }}>
                <span style={{ color:'var(--text-light)' }}>{r.l}</span>
                <span style={{ fontWeight:'600' }}>{r.v}</span>
              </div>
            ))}
          </div>
        )}

        <div style={{ textAlign:'left', marginBottom:'28px' }}>
          <div style={{ fontWeight:'600', fontSize:'14px', marginBottom:'10px' }}>What happens next</div>
          {['We call you to confirm the appointment','We match you with the right DHA-licensed therapist','Your therapist arrives at your home'].map((s,i) => (
            <div key={i} style={{ display:'flex', gap:'10px', alignItems:'center', padding:'7px 0', fontSize:'14px', color:'var(--text-light)' }}>
              <CheckIcon size={14} color="var(--teal)" />{s}
            </div>
          ))}
        </div>

        <div style={{ display:'flex', gap:'12px', justifyContent:'center', flexWrap:'wrap' }}>
          <a href="tel:+97100000000" className="btn-secondary" style={{ fontSize:'14px', padding:'10px 20px' }}>
            <PhoneIcon size={14} color="var(--teal)" /> Call Now
          </a>
          <a href="https://wa.me/97100000000" target="_blank" rel="noopener noreferrer" className="btn-whatsapp" style={{ fontSize:'14px', padding:'10px 20px' }}>
            <WhatsAppIcon size={14} color="white" /> WhatsApp
          </a>
        </div>
        <Link to="/" style={{ display:'block', marginTop:'20px', fontSize:'13px', color:'var(--text-light)' }}>← Back to home</Link>
      </div>
    </div>
  );
}
